// The actions the latest SEO scan adds up to. The items are the startup's own plan for its site,
// kept apart from the startup plan the assistant writes: they are read, refreshed, archived and
// completed here, and the startup plan's list returns them alongside its own for display only.
class WebsitePlan {

  constructor(basePath, apiClient) {

    this.basePath = `${basePath}/website-plan`;
    this.apiClient = apiClient;

  }

  async getItems() {

    const path = `${this.basePath}/items`;

    return this.apiClient.get(path, {}, {});

  }

  // Answers with the plan the refresh settled on, plus what it changed — a refresh asked for
  // before the site has ever been scanned reports `scanned: false` and leaves the plan alone.
  async refreshItems() {

    const path = `${this.basePath}/refresh`;

    return this.apiClient.post(path, {}, {}, {});

  }

  async sendItemAsMessage(itemId) {

    const path = `${this.basePath}/items/:itemId/as-message`;

    return this.apiClient.post(path, { itemId }, {}, {});

  }

  async archiveItem(itemId) {

    const path = `${this.basePath}/items/:itemId/archive`;

    return this.apiClient.put(path, { itemId }, {}, {});

  }

}

export default WebsitePlan;
